"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var App_1 = require("../../App");
var react_router_1 = require("react-router");
var __1 = require("../../");
var signup_1 = __importDefault(require("../pages/signup"));
var eloise_1 = __importDefault(require("../widgets/eloise"));
var chatStyles_1 = require("../styles/chatStyles");
/**
 * Renders content for the SideModal based on the current `sideWidget` prop.
 * @param {string} sideWidget - The name of the current side widget.
 * @returns {React.ReactNode} The component to render.
 */
var renderModalContent = function (sideWidget, holeCoords, setHoleCoords) {
    var siteConfig = (0, App_1.useEloise)().siteConfig;
    // Look up the page object in `siteConfig` with a name matching the `sideWidget` prop.
    var page = siteConfig.sideWidget.find(function (p) { return p.name === sideWidget; });
    // If no page is found with the matching name, return null.
    if (sideWidget !== "Eloise" && !checkNone(holeCoords)) {
        setHoleCoords({ top: 0, right: 0, left: 0, bottom: 0 });
    }
    if (!page) {
        if (sideWidget === 'Login') {
            return react_1.default.createElement(__1.Login, null);
        }
        else if (sideWidget === 'SignUp') {
            return react_1.default.createElement(signup_1.default, null);
        }
        else if (sideWidget === "Eloise") {
            return react_1.default.createElement(eloise_1.default, { holeCoords: holeCoords, setHoleCoords: setHoleCoords });
        }
        else {
            return null;
        }
    }
    return react_1.default.createElement(page.component, null);
};
var checkNone = function (holeCoords) {
    var top = holeCoords.top, right = holeCoords.right, bottom = holeCoords.bottom, left = holeCoords.left;
    return (top + right + bottom + left) === 0;
};
var SideModal = function (_a) {
    var _b;
    var navigate = (0, react_router_1.useNavigate)();
    var _c = (0, App_1.useEloise)(), theme = _c.theme, logic = _c.logic, siteConfig = _c.siteConfig;
    var themeC = theme;
    var _d = (0, react_1.useState)({ top: 0, right: 0, bottom: 0, left: 0 }), holeCoords = _d[0], setHoleCoords = _d[1];
    // Get the `sideWidget` prop from the current location state.
    // Get the `sideWidget` prop from the current location state.
    var sideWidget = (_b = (0, react_router_1.useLocation)().state) === null || _b === void 0 ? void 0 : _b.sideWidget;
    var pathName = (0, react_router_1.useLocation)().pathname;
    // If `sideWidget` is not present in the location state, don't render the modal.
    if (!sideWidget) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ModalOverlay, { onClick: function () { return navigate(pathName, { state: {} }); } },
            !checkNone(holeCoords) && react_1.default.createElement(chatStyles_1.StyledHole, { targetTop: holeCoords.top, targetBottom: window.innerHeight - holeCoords.bottom }),
            react_1.default.createElement(Row, null,
                react_1.default.createElement(ModalContent, { style: {
                        backgroundColor: 'white',
                        color: 'black',
                        borderRadius: '10px',
                        padding: '20px',
                        height: '70vh',
                        overflow: 'scroll'
                    }, onClick: function (e) { return e.stopPropagation(); } }, renderModalContent(sideWidget, holeCoords, setHoleCoords))))));
};
var slideIn = (0, styled_components_1.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(0);\n  }\n"], ["\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(0);\n  }\n"])));
var slideOut = (0, styled_components_1.keyframes)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n"], ["\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n"])));
var ModalOverlay = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: fixed;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  \n  /* Center the modal vertically and horizontally on mobile screens */\n  @media (max-width: 767px) {\n    align-items: flex-start;\n    justify-content: center;\n  }\n"], ["\n  position: fixed;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  \n  /* Center the modal vertically and horizontally on mobile screens */\n  @media (max-width: 767px) {\n    align-items: flex-start;\n    justify-content: center;\n  }\n"])));
var Row = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100vw;\n  display: flex;\n\n  &.modal-transition-enter {\n    animation: ", " 500ms forwards;\n  }\n\n  &.modal-transition-exit {\n    animation: ", " 500ms forwards;\n  }\n"], ["\n  width: 100vw;\n  display: flex;\n\n  &.modal-transition-enter {\n    animation: ", " 500ms forwards;\n  }\n\n  &.modal-transition-exit {\n    animation: ", " 500ms forwards;\n  }\n"])), slideIn, slideOut);
var ModalContent = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  border-radius: 10px;\n  width: 35%;\n  margin-left: 60%;\n  overflow-y: 'scroll';\n\n  @media (max-width: 1000px) and (min-width: 750px) {\n    margin: auto;\n    width: 50%;\n    margin-top: 10vh;\n  }\n  @media (max-width: 767px) {\n    margin: auto;\n    width: 90%;\n    margin-top: 10vh;\n  }\n"], ["\n  border-radius: 10px;\n  width: 35%;\n  margin-left: 60%;\n  overflow-y: 'scroll';\n\n  @media (max-width: 1000px) and (min-width: 750px) {\n    margin: auto;\n    width: 50%;\n    margin-top: 10vh;\n  }\n  @media (max-width: 767px) {\n    margin: auto;\n    width: 90%;\n    margin-top: 10vh;\n  }\n"])));
exports.default = SideModal;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
